import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// Shared UI Library Components
import { SpinElement } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './profile-layout.scss';

// Components
import { AsideMenu } from './components/aside-menu/aside-menu';

// Store Entities
import { getCoreState } from '../../store/core/core.selectors';
import { getUserState } from '../../store/user/user.selectors';
import { getUserProfile } from '../../store/user/user.thunks';

type TProfileLayoutProps = {};

export const ProfileLayout = ({}: TProfileLayoutProps) => {

  const { path } = useSelector(getCoreState);
  const { user, loading } = useSelector(getUserState);

  const dispatch = useDispatch<any>();

  const loadProfileInfo = (): void => {
    dispatch(getUserProfile());
  }

  useEffect(() => {
    loadProfileInfo();
  }, []);

  return (
    <div className="profile-layout">
      {
        loading &&
        <div className={ `profile-layout--loader profile-layout--loader-${ loading ? 'show' : 'hide' }` }>
          <SpinElement fullHeight={ true }/>
        </div>
      }

      <div className="profile-layout--content">
        <div className="content-aside">
          { user && <AsideMenu pathState={ path }/> }
        </div>
        <div className="content-body">
          <Outlet/>
        </div>
      </div>
    </div>
  );
}
